import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class SubscriptionManagerService {
  private subscriptions = {};

  addSubscription(component: any, subscriptionName: string, subscription: Subscription) {
    const cmp = component.constructor.name;
    if (typeof this.subscriptions[cmp] === 'undefined') {
      this.subscriptions[cmp] = {};
      this.subscriptions[cmp][subscriptionName] = subscription;
    }
    this.subscriptions[cmp][subscriptionName] = subscription;
  }

  removeSubscription(fullSubscriptionName: string) {
    const keys = fullSubscriptionName.split('.');
    if (keys && keys.length === 2) {
      this.subscriptions[keys[0]][keys[1]].unsubscribe();
    }
  }

  removeAllSubscriptions(component: any) {
    const subscriptions = this.subscriptions[component];
    if (!subscriptions) {
      return;
    }
    const subs = Object.keys(subscriptions);
    for (const sub of subs) {
      this.subscriptions[component][sub].unsubscribe();
    }
  }
}
